<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Bimestral
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>Turma: {{ gestaoDeAula.turma?.descricao }}</h4>
              <h4>
                Disciplina:
                {{
                  gestaoDeAula.is_polivalencia === 1
                    ? gestaoDeAula.disciplina
                    : gestaoDeAula.disciplina.descricao
                }}
              </h4>
              <h4>
                Professor:
                {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
              </h4>
            </v-card-text>
          </v-col>
          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="podeVerPlano"
                  x-small
                  class="ml-1 white--text"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  @click="() => verHistoricoPlanos()"
                >
                  <span>Histórico do lancamento de planos</span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-card>
      </v-col>
      <v-col cols="12 text-center" class="pt-2">
        <template>
          <v-toolbar>
            <v-tabs dark v-model="form.bimestre" background-color="primary" grow>
              <v-tab
                v-for="item of $constants.bimestres"
                :key="item.value"
                @click="() => atualizarPathAtual(item.value)"
              >
                <v-badge dot floating x-large v-if="form.bimestre === item.value" color="accent">
                  {{ item.desc }}
                </v-badge>
                <div v-else>{{ item.desc }}</div>
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </template>
      </v-col>
    </v-row>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }" v-if="!loadingPlano">
      <form @submit.prevent="handleSubmit(validarFormulario)" :disabled="submittingForm">
        <v-row>
          <v-col cols="12" class="my-2">
            <ValidationProvider name="Metodologia" rules="required|max:4000" v-slot="{ errors }">
              <e-label>OBJETO DE CONHECIMENTO</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].objeto_conhecimento"
                :error-messages="errors"
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12" class="my-2">
            <ValidationProvider name="Habilidades" rules="required|max:4000" v-slot="{ errors }">
              <e-label>HABILIDADES/OBJETIVOS</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].habilidades"
                :error-messages="errors"
                maxlength="4000"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12" class="my-2">
            <ValidationProvider
              name="Metodologia"
              :rules="{ required: true, minArray: 1 }"
              v-slot="{ errors }"
            >
              <div class="d-flex my-6">
                <e-label>METODOLOGIAS/ESTRATÉGIAS</e-label>
                <v-btn
                  class="ml-auto"
                  x-small
                  color="primary"
                  @click="selecionarTudo('metodologia')"
                  >Selecionar Tudo</v-btn
                >
                <v-btn class="ml-4" x-small color="secondary" @click="desmarcarTudo('metodologia')"
                  >Desmarcar Tudo</v-btn
                >
              </div>

              <v-row>
                <v-col
                  v-for="(item, index) in $constants.METODOLOGIA_PLANOS_BIMESTRAIS"
                  :key="index"
                  cols="12"
                  sm="4"
                  md="2"
                >
                  <v-checkbox
                    :label="item"
                    :value="item"
                    v-model="formData[bimestreAtual].metodologia"
                    dense
                    multiple
                  ></v-checkbox>
                </v-col>
              </v-row>

              <div v-if="(formData[bimestreAtual].metodologia || []).includes('Outros')">
                <v-label>OUTROS: </v-label>
                <ValidationProvider
                  name="Metodologias outros"
                  rules="required|max:4000"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="formData[bimestreAtual].metodologia_outros"
                    solo
                    dense
                    :error-messages="errors"
                    maxlength="4000"
                  ></v-textarea>
                </ValidationProvider>

                <e-label
                  ><small>*Obs:os items serão separados por um salto de linha.</small></e-label
                >
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" dark v-bind="attrs" v-on="on">
                      mdi mdi-help-circle
                    </v-icon>
                  </template>
                  <span>
                    <strong>Exemplo:</strong> <br />
                    Debate<br />
                    Estudo de Texto<br />
                    e etc.
                  </span>
                </v-tooltip>
              </div>

              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-col>

          <v-col cols="12" class="my-2">
            <ValidationProvider
              name="RECURSOS DIDÁTICOS"
              :rules="{ required: true, minArray: 1 }"
              v-slot="{ errors }"
            >
              <div class="d-flex my-6">
                <e-label>RECURSOS DIDÁTICOS</e-label>

                <v-btn
                  class="ml-auto"
                  x-small
                  color="primary"
                  @click="selecionarTudo('recursos_didaticos')"
                  >Selecionar Tudo</v-btn
                >
                <v-btn
                  class="ml-4"
                  x-small
                  color="secondary"
                  @click="desmarcarTudo('recursos_didaticos')"
                  >Desmarcar Tudo</v-btn
                >
              </div>

              <v-row>
                <v-col
                  v-for="(item, index) in $constants.RECURSOS_DIDATICOS_PLANOS_BIMESTRAIS"
                  :key="index"
                  cols="12"
                  sm="4"
                  md="2"
                >
                  <v-checkbox
                    :label="item"
                    :value="item"
                    v-model="formData[bimestreAtual].recursos_didaticos"
                    dense
                    multiple
                  ></v-checkbox>
                </v-col>
              </v-row>

              <div v-if="(formData[bimestreAtual].recursos_didaticos || []).includes('Outros')">
                <v-label>OUTROS: </v-label>
                <ValidationProvider
                  name="Recursos didáticos outros"
                  rules="required|max:4000"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="formData[bimestreAtual].recursos_didaticos_outros"
                    solo
                    dense
                    :error-messages="errors"
                    maxlength="4000"
                  ></v-textarea>
                  <e-label
                    ><small>*Obs:os items serão separados por um salto de linha.</small></e-label
                  >
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on">
                        mdi mdi-help-circle
                      </v-icon>
                    </template>
                    <span>
                      <strong>Exemplo:</strong> <br />
                      Livro Didático e Caderno<br />
                      Projetor / Computador<br />
                      e etc.
                    </span>
                  </v-tooltip>
                </ValidationProvider>
              </div>

              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-col>

          <v-col cols="12" class="my-2">
            <ValidationProvider
              name="Avaliação da aprendizagem"
              :rules="{ required: true, minArray: 1 }"
              v-slot="{ errors }"
            >
              <div class="d-flex my-6">
                <e-label>ATIVIDADES AVALIATIVAS</e-label>

                <v-btn
                  class="ml-auto"
                  x-small
                  color="primary"
                  @click="selecionarTudo('avaliacao_aprendizagem')"
                  >Selecionar Tudo</v-btn
                >
                <v-btn
                  class="ml-4"
                  x-small
                  color="secondary"
                  @click="desmarcarTudo('avaliacao_aprendizagem')"
                  >Desmarcar Tudo</v-btn
                >
              </div>

              <v-row>
                <v-col
                  v-for="(item, index) in $constants.AVALIACAO_APRENDIZAGEM_PLANOS_BIMESTRAIS"
                  :key="index"
                  cols="12"
                  sm="4"
                  md="2"
                >
                  <v-checkbox
                    :label="item"
                    :value="item"
                    v-model="formData[bimestreAtual].avaliacao_aprendizagem"
                    dense
                    multiple
                  ></v-checkbox>
                </v-col>
              </v-row>

              <div v-if="(formData[bimestreAtual].avaliacao_aprendizagem || []).includes('Outros')">
                <v-label>OUTROS: </v-label>

                <ValidationProvider
                  name="Avaliação de aprendizagem outros"
                  rules="required|max:2000"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="formData[bimestreAtual].avaliacao_aprendizagem_outros"
                    solo
                    dense
                    :error-messages="errors"
                    maxlength="2000"
                  ></v-textarea>
                  <e-label
                    ><small>*Obs:os items serão separados por um salto de linha.</small></e-label
                  >
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on">
                        mdi mdi-help-circle
                      </v-icon>
                    </template>
                    <span>
                      <strong>Exemplo:</strong> <br />
                      Avaliação Escrita <br />
                      Avaliação Qualitativa <br />
                      e etc.
                    </span>
                  </v-tooltip>
                </ValidationProvider>
              </div>

              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-col cols="12" class="mt-5">
          <v-row>
            <v-btn
              block
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
    <v-row v-else>
      <v-col cols="12">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader
          ><v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader
          ><v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
    <e-drawer-planos-lancados
      v-model="openDrawer"
      :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
      :bimestre="parseInt(form.bimestre, 10)"
      :disciplina_id="disciplina_id"
      @reloadPage="reloadPageData"
    />
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import ELabel from "../../components/ELabel.vue";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  async mounted() {
    this.loadingPlano = true;
    await this.loadData().then(() => {
      this.loadingPlano = false;
    });
  },
  data() {
    return {
      submittingForm: false,
      form: {
        bimestre: 0,
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
        disciplinas: [],
      },
      loadingPlano: true,
      plano_bimestral: [],
      path: null,
      pathsList: [],
      pathAtual: [],
      formData: {
        0: { metodologia: [] }, // Exemplo para bimestre 0
        1: { metodologia: [] },
        2: { metodologia: [] },
        3: { metodologia: [] },
      },
      selectedTab: 0,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    podeVerPlano() {
      return this.$constants.rolesParaGestores.find(
        (rpg) =>
          rpg.name ===
          this.user.roles.filter((role) => role.name === "super-admin").find((r) => true)?.name
      );
    },
    bimestreAtual() {
      return this.form.bimestre;
    },
    disciplina_id() {
      return parseInt(this.$route.params.disciplinaId, 10);
    },
    gestao_de_aula_id() {
      return parseInt(this.$route.params.gestaoDeAulaId, 10);
    },
  },
  methods: {
    async validarFormulario() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$toast.error("Corrija os erros antes de salvar!");
        return;
      }
      this.salvarPlanos();
    },
    async salvarPlanos() {
      this.$loaderService.open("Carregando dados...");
      try {
        const planos = Object.values(this.formData).map((item) => ({
          ...item,
          instrutorDisciplinaTurma_id: this.gestao_de_aula_id,
          disciplina_id: this.disciplina_id,
        }));

        await this.$services.planosBimestraisService.salvarPlanos(
          planos,
          this.gestao_de_aula_id,
          this.disciplina_id
        );

        await this.loadData();
        this.$toast.success("Planos salvos com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    atualizarPathAtual(bimestre) {
      this.pathAtual = this.formData[bimestre].path;
    },
    async onFileSelected(file) {
      if (file) {
        const { gestaoDeAulaId, disciplinaId } = this.$route.params;

        try {
          const response = await this.$services.planosBimestraisService.planoBimestralPDF(
            gestaoDeAulaId,
            this.bimestreAtual,
            disciplinaId,
            file
          );

          // console.log("Arquivo enviado com sucesso:", response);
          this.pathAtual = response.path;
          this.formData[bimestre].path = response.path;
        } catch (error) {
          // console.error("Erro ao enviar o arquivo:", error);
        } finally {
          this.isUploading = false;
        }
      }
    },
    async downloadPlanoBimestral() {
      const { gestaoDeAulaId, disciplinaId } = this.$route.params;
      try {
        await this.$services.planosBimestraisService.planoBimestralDownload(
          gestaoDeAulaId,
          this.bimestreAtual,
          disciplinaId
        );
      } catch (error) {
        // console.error("Erro ao baixar o arquivo:", error);
      }
    },
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async createOrUpdate() {
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        const { bimestre } = this.form;
        this.form.bimestre = bimestre;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplina_id;
        await this.$services.planosBimestraisService.createOrUpdate(this.form);
        this.$toast.success("Plano bimestral salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async loadData() {
      const { gestaoDeAulaId, disciplinaId } = this.$route.params;

      try {
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(gestaoDeAulaId);

        const response = await this.$services.planosBimestraisService.pegarPlanos(
          gestaoDeAulaId,
          disciplinaId
        );

        const bimestresExistentes = [];
        response.planos.map((plano, index) => {
          this.formData[plano.bimestre] = {
            ...plano,
            metodologia: plano.metodologia || [],
            recursos_didaticos: plano.recursos_didaticos || [],
            avaliacao_aprendizagem: plano.avaliacao_aprendizagem || [],
          };
          bimestresExistentes.push(plano.bimestre);
        });

        const bimestresInexistenes = this.$constants.bimestres
          .filter((bimestre) => {
            return !bimestresExistentes.includes(bimestre.value);
          })
          .map((b) => b.value);

        bimestresInexistenes.map((bimestre) => {
          this.formData[bimestre] = {
            instrutorDisciplinaTurma_id: gestaoDeAulaId,
            disciplina_id: disciplinaId,
            bimestre,
            metodologia: [],
            recursos_didaticos: [],
            avaliacao_aprendizagem: [],
          };
        });

        if (response.planos.length > 0) {
          this.pathsList = response.planos.map((i) => i.path);
          this.pathAtual = this.pathsList[this.bimestreAtual];
        }

        if (this.gestaoDeAula.disciplinas.length > 0) {
          const disciplina = this.gestaoDeAula.disciplinas.filter((i) => {
            return i.id === this.disciplina_id;
          });
          this.gestaoDeAula.disciplina = disciplina[0].descricao;
        }

        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
    },
    async reloadPageData() {
      await this.loadData();
    },
    selecionarTudo(campo) {
      this.formData[this.bimestreAtual][campo] = [
        ...this.$constants[`${campo.toUpperCase()}_PLANOS_BIMESTRAIS`],
      ];
    },
    desmarcarTudo(campo) {
      this.formData[this.bimestreAtual][campo] = [];
    },
  },
};
</script>

<style></style>
